export { default } from "@modules/auth/pages/CustomerLoginPage"
